exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-list-item__container__16cqH{position:relative;overflow:hidden}", ""]);

// exports
exports.locals = {
	"container": "video-list-item__container__16cqH"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/views/desktop/strip/components/videos/video-list-item/video-list-item.styl
// module id = 2945
// module chunks = 1